import Vue from 'vue';
import VueRouter from 'vue-router';
import VueAnalytics from 'vue-analytics';
import VueGtag from 'vue-gtag';
import AppConfig from '../AppConfig';

export function registerAnalytics (router: VueRouter): void {
	if (AppConfig.gtagAnalyticsPropertyId) {
		// we can use a Universal Analytics Property ID with GA4. See
		// https://developers.google.com/analytics/devguides/migration/measurement/add-ga4?technology=analyticsjs
		// https://matteo-gabriele.gitbook.io/vue-gtag/v/master/multiple-domain-tracking

		const config = {
			id: AppConfig.googleAnalyticsTrackingId
				? AppConfig.googleAnalyticsTrackingId // ua property
				: AppConfig.gtagAnalyticsPropertyId // ga4 property
		};

		const includes = AppConfig.googleAnalyticsTrackingId ? [{ id: AppConfig.gtagAnalyticsPropertyId }] : [];

		Vue.use(VueGtag, { config, includes }, router);
	} else if (AppConfig.googleAnalyticsTrackingId) {
		// vue-analytics will no longer process data after July 1 2023

		Vue.use(VueAnalytics, {
			id: AppConfig.googleAnalyticsTrackingId,
			// disabled: true
			router
		});
	}
}
